import { createSelector } from 'reselect'
import { isEmpty, isLoaded } from 'react-redux-firebase'

export const firebaseSelector = state => state.firebase.data
export const firebaseOrderedSelector = state => state.firebase.ordered
export const authSelector = state => state.firebase.auth
export const profileSelector = state => state.firebase.profile
export const userIdSelector = createSelector(
  [authSelector],
  auth => auth && auth.uid
)
export const anonSelector = createSelector(
  [authSelector],
  auth => auth.isAnonymous
)

/**
 * Get full user details - profile and auth
 * @param {Selector} authSelector
 * @param {Selector} profileSelector
 * @return {object} user
 */
export const userSelector = createSelector(
  [authSelector, profileSelector],
  (auth, profile) => {
    // anon users have no profile
    if (auth.isAnonymous) return auth

    if (!isLoaded(profile)) return { isLoaded: false }
    if (!profile || isEmpty(profile)) return { isEmpty: true }

    return { id: auth.uid, ...auth, ...profile }
  }
)
